// noinspection ES6UnusedImports
import React, {Fragment, useEffect, useState} from 'react';
import MessageBroker from 'deprecated-shared-ui/components/message-broker';
import WishlistMessages from '@shopping-funnel/scripts/components/messages';
import {Typography} from '@bonprix/design-system';

export default function WishlistHeader({
                                           wishlistCount,
                                           texts
}) {
    const [currentWishlistCount, setCurrentWishlistCount] = useState(wishlistCount);

    useEffect(() => {
        const subscriptions = [
            MessageBroker.subscribe(WishlistMessages.WISHLIST.ITEM_ADDED, (messageData) => {
                if (messageData.amountAdded) {
                    setCurrentWishlistCount((prevCount) => prevCount + messageData.amountAdded);
                }
            }),
            MessageBroker.subscribe(WishlistMessages.WISHLIST.ITEM_DELETED, (messageData) => {
                if (typeof messageData.currentItemsInWishlist === 'number') {
                    setCurrentWishlistCount(messageData.currentItemsInWishlist);
                }
            }),
        ];

        return () => subscriptions.forEach((subscription) => MessageBroker.unsubscribe(subscription));
    }, []);

    const ItemCountElement =
        wishlistCount !== 0 ? (
            <div className="wishlist-headline__itemcount">
                <span>{currentWishlistCount}</span> {texts.wishlist_artikel}
            </div>
        ) : null;

    return (
        <Fragment>
            <div className="wishlist__headline">
                <Typography variant="bonprix-h4" component="h1" align="center">
                    {texts.wishlist2023_wishlist_headline}
                </Typography>
            </div>
            <Typography component="span">
                {ItemCountElement}
            </Typography>
        </Fragment>
    );
}
